import { client } from '../../graphql/client';
import { getSelectedTenant } from "../../service/store";
import { SearchTenants } from "../../graphql/generated-queries/tenants-queries";

export async function getTenants(input) {

  const variables = {
    ...input.filter,
    perPage: input.pagination.perPage,
    skip: (input.pagination.page - 1) * input.pagination.perPage,
    order: [
      {[input.sort.field]: input.sort.order}
    ]
  }

  const tenant = getSelectedTenant();
  const tenantId = tenant ? tenant.tenantId : null;

  try {
    const { data } = await client.query({ query: SearchTenants, variables: {...variables, tenantId } } );
    return { data: data.searchTenants.items, total: data.searchTenants.total };
  } catch (err) {
    console.error(err);
  }
}
